import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 9/10;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 9 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Docs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Doc" transform="translate(-436.000000, -317.000000)" fill={color}>
                <g id="Group-10" transform="translate(421.000000, 180.000000)">
                    <g id="Group-7" transform="translate(11.000000, 133.000000)">
                        <path d="M8.8671875,14 L4.90917969,14 L4.90917969,4.13574219 L8.84667969,4.13574219 C10.5966797,4.13574219 11.7451172,5.10644531 11.7451172,6.59667969 C11.7451172,7.64257812 10.9726562,8.57910156 9.98828125,8.74316406 L9.98828125,8.79785156 C11.328125,8.94824219 12.2304688,9.8984375 12.2304688,11.2109375 C12.2304688,12.9472656 10.9658203,14 8.8671875,14 Z M6.44042969,5.38671875 L6.44042969,8.33300781 L8.15625,8.33300781 C9.48242188,8.33300781 10.2138672,7.78613281 10.2138672,6.80859375 C10.2138672,5.89257812 9.58496094,5.38671875 8.47753906,5.38671875 L6.44042969,5.38671875 Z M6.44042969,12.7490234 L8.55273438,12.7490234 C9.93359375,12.7490234 10.6650391,12.1816406 10.6650391,11.1152344 C10.6650391,10.0488281 9.91308594,9.50195312 8.46386719,9.50195312 L6.44042969,9.50195312 L6.44042969,12.7490234 Z" id="Bold"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconFormatBold extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
